import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";

import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";
import styles from "../AddEvent.module.scss";
import "../AddEvent.scss";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";

function AddRolesModal({
  t,
  issaveRolesModalOpen,
  setIsSaveRolesModalOpen,
  designationIds,
  setDesignationIds,
  userRoles,
  eventId,
}) {
  const [selectedDesignation, setSelectedDesignation] = useState([
    ...designationIds,
  ]);

  const checkDesignation = (designation) => {
    const dIndex = selectedDesignation.findIndex(
      (e) => e.designationsId === designation.id
    );
    if (dIndex > -1) {
      if (selectedDesignation?.[dIndex]?.isFromDetail === false) {
        selectedDesignation.splice(dIndex, 1);
      } else {
        selectedDesignation[dIndex].IsDeleted =
          !selectedDesignation?.[dIndex]?.IsDeleted;
      }
    } else {
      selectedDesignation.push({
        id: 0,
        schedulerEventId: eventId || 0,
        designationsId: designation.id,
        IsDeleted: false,
        isFromDetail: false,
      });
    }
    setSelectedDesignation([...selectedDesignation]);
  };

  const checkMemberRoleAvaliable = (array, value) => {
    return array?.some(
      (e) => e?.designationsId === value?.id && e?.IsDeleted === false
    );
  };
  const allValues = useMemo(
    () =>
      userRoles?.reduce((prev, element) => {
        element.designations.forEach(() => {
          prev += 1;
        });
        return prev;
      }, 0),
    [userRoles]
  );
  const selectAll = useMemo(
    () =>
      allValues > 0 &&
      selectedDesignation.filter((res) => !res.IsDeleted).length === allValues,
    [allValues, selectedDesignation]
  );
  const handleAllChange = (e) => {
    const checked = e.target.checked;
    const values = [];
    const existingSet = new Map();
    if (eventId) {
      designationIds.forEach((res, i) => {
        existingSet.set(res.designationsId, i);
      });
    }
    if (checked) {
      userRoles.forEach((element) => {
        element.designations.forEach((val) => {
          values.push({
            id: existingSet.has(val.id)
              ? designationIds[existingSet.get(val.id)].id
              : 0,
            schedulerEventId: eventId ? eventId : 0,
            designationsId: val.id,
            IsDeleted: false,
            isFromDetail: false,
          });
        });
      });
    } else {
      designationIds.forEach((res, i) => {
        if (res.id) {
          res.IsDeleted = true;
          values.push({ ...res });
        }
      });
    }
    setSelectedDesignation(values);
  };

  return (
    <Modal
      isOpen={issaveRolesModalOpen}
      toggle={() => setIsSaveRolesModalOpen(false)}
      className={"modal-dialog-centered " + styles["add-roles-modal-dialog"]}
      modalClassName="custom-modal"
    >
      <span
        className="close-btn"
        onClick={() => setIsSaveRolesModalOpen(false)}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
          <span className="modal-title-25">{t("accountOwner.addRoles")}</span>
        </Text>

        <Text
          size="12px"
          marginBottom="10px"
          weight="400"
          color="rgb(111, 119, 136)"
        >
          {selectedDesignation?.filter((e) => e.IsDeleted === false)?.length}{" "}
          {t("Selected")}
        </Text>
        {/* Select all checkbox */}
        {userRoles?.length > 0 && (
          <div className="ch-checkbox c-field all-event-checkbox m-0">
            <label>
              <input
                type="checkbox"
                onChange={handleAllChange}
                checked={selectAll}
              />
              <span>{t("staff.selectAll")}</span>
            </label>
          </div>
        )}
        <Accordion
          className={["add-role-accordion contract-detail-accordion"]}
          preExpanded={[0]}
        >
          {userRoles.length > 0 &&
            userRoles.map((item, index) => (
              <AccordionItem uuid={index} key={item.id}>
                <AccordionItemHeading>
                  <AccordionItemButton>{item.name}</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <ul className={styles["roles-list"]}>
                    {item.designations.map((val) => (
                      <li key={val.id}>
                        <div className="ch-checkbox">
                          <label>
                            <input
                              type="checkbox"
                              checked={checkMemberRoleAvaliable(
                                selectedDesignation,
                                val
                              )}
                              onChange={() => checkDesignation(val)}
                            />
                            <span> {val.name}</span>
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </AccordionItemPanel>
              </AccordionItem>
            ))}
        </Accordion>

        <button
          className="button button-round button-shadow mr-sm-3 mb-3 w-sm-100"
          title={t("accountOwner.addRoles")}
          onClick={() => {
            setDesignationIds(selectedDesignation);
            setIsSaveRolesModalOpen(false);
          }}
        >
          {t("accountOwner.addRoles")}
        </button>
        <button
          className="button btn-mobile-link button-round button-border button-dark "
          onClick={() => setIsSaveRolesModalOpen(false)}
          title={t("cancel")}
        >
          {t("cancel")}
        </button>
      </ModalBody>
    </Modal>
  );
}

export default withTranslation()(AddRolesModal);
